import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.074 8.292a.75.75 0 0 1 0 1.5H7.75a3.25 3.25 0 0 0-3.25 3.25v3.762a3.25 3.25 0 0 0 3.25 3.25h8.5a3.25 3.25 0 0 0 3.25-3.25v-3.762a3.25 3.25 0 0 0-3.25-3.25h-.32a.75.75 0 0 1 0-1.5h.32a4.75 4.75 0 0 1 4.75 4.75v3.762a4.75 4.75 0 0 1-4.75 4.75h-8.5A4.75 4.75 0 0 1 3 16.804v-3.762a4.75 4.75 0 0 1 4.75-4.75zM11.47 2.22a.75.75 0 0 1 1.06 0l3.296 3.296a.75.75 0 0 1-1.061 1.06L12.75 4.56v10.337a.75.75 0 0 1-1.5 0V4.56L9.234 6.576a.75.75 0 0 1-1.06-1.06z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
}
var IcShare = createNolIcon(/*#__PURE__*/forwardRef(SvgIcShare));

export { IcShare as I };
